"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = require("vue-multiselect");

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _functions = require("../../utilities/functions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: { Multiselect: _vueMultiselect2.default },

  data: function data() {
    return {
      initial: null,
      locales: [{
        locale: "en",
        name: "English",
        picture: "/img/flags/gb.svg"
      }, {
        locale: "sv",
        name: "Svenska",
        picture: "/img/lang/sweden.svg"
      }]
    };
  },
  mounted: function mounted() {
    var currentLocale = this.$i18n.locale;

    this.initial = this.locales.find(function (locale) {
      return locale.locale === currentLocale;
    });
  },


  methods: {
    switchLocale: function switchLocale(_ref) {
      var selectedLocale = _ref.locale;

      if ((0, _functions.storageAvailable)("localStorage")) {
        localStorage.locale = selectedLocale;
      }

      this.$i18n.locale = selectedLocale;
      this.$store.commit("changeLocale", selectedLocale);

      if (window.globals.user) {
        axios.patch("/user/profile-locale", {
          locale: selectedLocale
        }).then(function (result) {
          window.globals.user.locale = selectedLocale;
        });
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/general/LocaleSwitcher.vue
// module id = yI3N
// module chunks = 0 1